import EmailReader from '@admin/components/email_reader'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  component: <EmailReader response={ props.response } />
})

export default Panel(null, mapPropsToPanel)
